<template>
    <div>
        <rkm-form ref="RkmForm">

            <rkm-row>
                <rkm-col cols="8">
                    <rkm-form-input
                        label="Modelo"
                        v-model="model.modelo"
                        :validations="validations.modelo"
                        uppercase
                    />
                </rkm-col>

                <rkm-col cols="4">
                    <rkm-form-input
                        label="Ano"
                        v-model="model.ano"
                        number
                        :validations="validations.ano"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-form>
    </div>
</template>

<script>
// Mixins.
import { repository } from '@/mixins'

// Enums.
import alergiaCriticidades from '@/enums/cadastro/cidadao/alergiaCriticidade'

export default {
    computed: {
        validations() {
            return {
                modelo: { required: true },
                ano: { required: true, min_max_without_mask: 4},
            }
        },
    },
    data: () => ({
        model: {
            tipoId: null,
            criticidadeId: 1,
            alergia: null,
            reacoesObservacoes: null,
        },
        enums: { alergiaCriticidades }
    }),
    methods: {
        setAutocompleteAlergia(alergia) {

            this.model.tipoId = alergia.tipo.id
            this.model.alergia = alergia
        },
        setModel(model) {

            this.model = model
        },
        save() {
            this.$refs.RkmForm.validate().then(response => {

                if (response === true) {

                    const data = {
                        index: this.index,
                        ano: this.model.ano,
                        modelo: this.model.modelo,
                    }

                    if (this.data.model.veiculos.length !== this.index) {
                        Object.assign(this.data.model.veiculos[this.index], data)
                    } else {
                        this.data.model.veiculos.push(data)
                    }

                    this.$emit('save', data)
                }
            })
        },
    },
    mixins: [repository],
    props: {
        data: { type: Object, required: true },
        index: { type: Number, required: true },
    },
}
</script>